import { render } from "./HealthCheckView.vue?vue&type=template&id=20a6ed69&scoped=true&ts=true"
import script from "./HealthCheckView.vue?vue&type=script&lang=ts"
export * from "./HealthCheckView.vue?vue&type=script&lang=ts"

import "./HealthCheckView.vue?vue&type=style&index=0&id=20a6ed69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a6ed69"]])

export default __exports__